<template>
  <div>
    <div class="clearfix mb-3">
      <div class="page-title float-left">자가진단 평가</div>
      <div class="float-right" v-if="mode=='TEST'"><mdb-btn icon="check" class="py-2" @click="onSave">제출하기</mdb-btn></div>
    </div>
    <test-common-process v-if="mode === 'CHECKTEST'" v-model="mode"/>
    <div v-if="mode === 'TEST'">
      <div v-for="(u, ux) in units" :key="ux">
        <div class="title">{{u.name}}/{{u.code}}</div>
        <mdb-tbl>
          <mdb-tbl-head>
            <tr class="title">
              <th class="bolder">수행준거</th>
              <th class="text-center bolder" style="width:80px">예</th>
              <th class="text-center bolder" style="width:80px">아니오</th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr v-for="(c,ix) in u.content" :key="ix">
              <td>{{c}}</td>
              <td class="text-center"><input :name="ux+'-'+ix" type="radio" v-model="answer.units[ux].answer[ix]" :value="true"></td>
              <td class="text-center"><input :name="ux+'-'+ix" type="radio" v-model="answer.units[ux].answer[ix]" :value="false"></td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </div>
    </div>
    <div class="text-right"  v-if="mode=='TEST'"><mdb-btn icon="check" class="py-2" @click="onSave">제출하기</mdb-btn></div>
  </div>
</template>
<script>
import { mdbTbl, mdbTblBody, mdbTblHead } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import TestCommonProcess from '@/components/test/TestCommonProcess.vue';
import SelfTestAnswer from '@/models/test/SelfTestAnswer'
export default {
  components: { mdbTbl, mdbTblBody, mdbTblHead, TestCommonProcess },
  name: 'StudentSelfTestExam',
  computed: {
    ...mapState('auth', ['profile']),
    ...mapGetters('training', ['lecture']),
    units () {
      return this.lecture(this.$route.query) ? this.lecture(this.$route.query).units : []
    }
  },
  data: () => ({
    mode: 'CHECKTEST',
    answer: {}
  }),
  methods: {
    async load () {
      if (!this.profile._id) return
      const student = this.profile._id
      const training = this.profile.training._id
      const code = this.$route.query.code
      this.answer = SelfTestAnswer.create(training, student, code, this.units)
    },
    async onSave () {
      if (!confirm('제출할까요?')) return
      await this.answer.save()
      this.$router.back()
    }
  },
  created () {
    this.load()
  },
  watch: {
    profile () {
      this.load()
    }
  }
}
</script>
